<template>
  <b-container>
    <b-row>
      <b-col sm="3">
        <Filters>
          <div class="search-box">
            <h4 class="text-center">السعر</h4>
            <VueSlider v-model="priceRange"  :min="0" :max="500" :interval="2"></VueSlider>
            <h4 class="text-center">{{priceRange[1] + '~' + priceRange[0]}}</h4>
          </div>
        </Filters>
      </b-col>
      <b-col sm="9">
        <b-row>
          <b-col sm="4" cols="6" v-for="s in 6" :key="s">
            <SingleTours :stars="3"/>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<script type="text/javascript">
import SingleTours   from '../global/SingleTours'
import Filters         from '../global/Filters'
import VueSlider       from 'vue-slider-component'
//class
import 'vue-slider-component/theme/default.css'

  export default {
    name:'ProgramsConetnt',
    components:{
      SingleTours,
      VueSlider,
      Filters
    },
    data() {
      return {
        searchCity:'',
        searchProg:'',
        priceRange:[100, 400],
        progs: [
          {
            name:'الايمارات'
          },
          {
            name:'قطر'
          },
          {
            name:'لبنان'
          }
        ],
        cyties:[
          {
            name:'العين السحنه',
          },
          {
            name:'شرم الشيخ',
          },
          {
            name:'الاقصر'
          },
        ]
      }
    },
    methods: {
      //search Programs
      searchProgFunction() {
        var vm = this;
        return this.progs.filter(function(prog){
          return prog.name.indexOf(vm.searchProg) !== -1
        })
      },

      //search city
      searchCityFunction() {
        var vm = this
        return this.cyties.filter(function (city) {
          return city.name.indexOf(vm.searchCity) !== -1
        })
      }
    },
    watch: {
      'searchCity' : function() {
        this.searchCityFunction()
      },
      'searchProg' : function() {
        this.searchProgFunction()
      }
    }
  }
</script>
